import commonApi from './CommonApi.js';

var qs = require('querystring');

export default {
	getForDropdown: async (parameter) => {
		return await commonApi().get('/v1/countries/getForDropdown', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getWorldCountriesForDropdown: async (parameter) => {
		return await commonApi().get('/v1/countries/getWorldCountriesForDropdown', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getEpingCountriesForDropdown: async (parameter) => {
		return await commonApi().get('/v1/countries/getEpingCountriesForDropdown', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getWtoMembersForDropdown: async (parameter) => {
		return await commonApi().get('/v1/countries/getWtoMembersForDropdown', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getWtoObserversForDropdown: async (parameter) => {
		return await commonApi().get('/v1/countries/getWtoObserversForDropdown', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getCurrentUserCountryCode: async (parameter) => {
		return await commonApi().get('/v1/countries/getCurrentUserCountryCode', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getUserCountryCodeLanguages: async (parameter) => {
		return await commonApi().get('/v1/countries/getUserCountryCodeLanguages', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getCountriesLanguage: async (parameter) => {
		return await commonApi().get('/v1/countries/getCountriesLanguage', 
			{
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getAll: async (parameter) => {
		return await commonApi().get('/v1/countries/getAll', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getItem: async (parameter) => {
		return await commonApi().get('/v1/countries/getItem', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
}